
import {Component, Mixins} from "vue-property-decorator"
import Common from '@/mixins/common'
import { getCountFromServer, getDocs, limit, orderBy, query, startAt } from "firebase/firestore"
import { EventData } from "@/common-datatypes"

@Component({
  components: {
  }
})

export default class NotificationEvents extends Mixins(Common){
  get userId(){
    return this.$store.getters.userId
  }

  isShow = true

  isLoading = false

  latestEvent = {} as EventData

  count = 0

  async created(){
    try{
      this.isLoading = true
    
      const eventsQuery = query(this.$getUserEventsColRef(),orderBy('start','asc'),startAt(new Date()))

      const aggregate = (await getCountFromServer(eventsQuery)).data()

      this.count = aggregate.count

      if(aggregate.count > 0){
        this.count = aggregate.count
        const latestEventQuery = query(eventsQuery,limit(1))
        const eventsDocs = await getDocs(latestEventQuery)
        if(eventsDocs.size === 1){
          this.latestEvent = eventsDocs.docs[0].data()
        }
      }

    }catch(e){
      console.error(e)
    }finally{
      this.isLoading = false
    }

  }
}
